import { combineReducers } from 'redux';

import visits from './visits';
import lastVerification from './lastVerification';

import allPets from './allPets';
import activePet from './activePet';
import purchases from './purchases';

import collectedGoodies from './collectedGoodies';
import activeGoodies from './activeGoodies';

export default combineReducers({
  visits,
  lastVerification,

  allPets,
  activePet,
  purchases,

  collectedGoodies,
  activeGoodies,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js